const createConstant = (name, value) => {
    Object.defineProperty(module.exports, name, {
        value,
        enumerable: true,
        writable: false,
    });
};

createConstant('WINDOWS', 'windows');
createConstant('LINUX', 'linux');

createConstant('M11_5_03', 'm11_5_03');
createConstant('M11_4_12', 'm11_4_12');
createConstant('M11_4_09', 'm11_4_09');
createConstant('M11_4_06', 'm11_4_06');
createConstant('M11_4_03', 'm11_4_03');
createConstant('M11_3_12', 'm11_3_12');
createConstant('M11_3_11', 'm11_3_11');
createConstant('M11_3_10', 'm11_3_10');
createConstant('M11_3_9', 'm11_3_9');
createConstant('M11_3_8', 'm11_3_8');
createConstant('M11_3_7', 'm11_3_7');
createConstant('M11_3_6', 'm11_3_6');
createConstant('M11_3_5_2', 'm11_3_5_2');
createConstant('M11_3_5_1', 'm11_3_5_1');
createConstant('M11_3_5', 'm11_3_5');
createConstant('M11_3_4_1', 'm11_3_4_1');
createConstant('M11_3_4', 'm11_3_4');
createConstant('M2021', 'm2021');
createConstant('M2021_UPDATE1', 'm2021_update1');
createConstant('M2021_UPDATE2', 'm2021_update2');
createConstant('M2021_UPDATE3', 'm2021_update3');
createConstant('CUSTOM_INSTALL', 'custom_install');
createConstant('EXPRESS_INSTALL', 'express_install');

createConstant('LINUX_11_5_03', 'linux_11_5_03');
createConstant('LINUX_11_4_12', 'linux_11_4_12');
createConstant('LINUX_11_4_09', 'linux_11_4_09');
createConstant('LINUX_11_4_06', 'linux_11_4_06');
createConstant('LINUX_11_4_03', 'linux_11_4_03');
createConstant('LINUX_11_3_12', 'linux_11_3_12');
createConstant('LINUX_11_3_11', 'linux_11_3_11');
createConstant('LINUX_11_3_10', 'linux_11_3_10');
createConstant('LINUX_11_3_9', 'linux_11_3_9');
createConstant('LINUX_11_3_8', 'linux_11_3_8');
createConstant('LINUX_11_3_7', 'linux_11_3_7');
createConstant('LINUX_11_3_6', 'linux_11_3_6');
createConstant('LINUX_11_3_5_2', 'linux_11_3_5_2');
createConstant('LINUX_11_3_5_1', 'linux_11_3_5_1');
createConstant('LINUX_11_3_5', 'linux_11_3_5');
createConstant('LINUX_11_3_4_1', 'linux_11_3_4_1');
createConstant('LINUX_11_3_4', 'linux_11_3_4');
createConstant('LINUX_21', 'linux_21');
createConstant('LINUX_21_UPDATE1', 'linux_21_update1');
createConstant('LINUX_21_UPDATE2', 'linux_21_update2');
createConstant('LINUX_21_UPDATE3', 'linux_21_update3');

createConstant('WINDOWS_11_5_03_CUSTOM', 'windows_11_5_03_custom');
createConstant('WINDOWS_11_5_03_EXPRESS', 'windows_11_5_03_express');
createConstant('WINDOWS_11_4_12_CUSTOM', 'windows_11_4_12_custom');
createConstant('WINDOWS_11_4_12_EXPRESS', 'windows_11_4_12_express');
createConstant('WINDOWS_11_4_09_CUSTOM', 'windows_11_4_09_custom');
createConstant('WINDOWS_11_4_09_EXPRESS', 'windows_11_4_09_express');
createConstant('WINDOWS_11_4_06_CUSTOM', 'windows_11_4_06_custom');
createConstant('WINDOWS_11_4_06_EXPRESS', 'windows_11_4_06_express');
createConstant('WINDOWS_11_4_03_CUSTOM', 'windows_11_4_03_custom');
createConstant('WINDOWS_11_4_03_EXPRESS', 'windows_11_4_03_express');
createConstant('WINDOWS_11_3_12_CUSTOM', 'windows_11_3_12_custom');
createConstant('WINDOWS_11_3_12_EXPRESS', 'windows_11_3_12_express');
createConstant('WINDOWS_11_3_11_CUSTOM', 'windows_11_3_11_custom');
createConstant('WINDOWS_11_3_11_EXPRESS', 'windows_11_3_11_express');
createConstant('WINDOWS_11_3_10_CUSTOM', 'windows_11_3_10_custom');
createConstant('WINDOWS_11_3_10_EXPRESS', 'windows_11_3_10_express');
createConstant('WINDOWS_11_3_9_CUSTOM', 'windows_11_3_9_custom');
createConstant('WINDOWS_11_3_9_EXPRESS', 'windows_11_3_9_express');
createConstant('WINDOWS_11_3_8_CUSTOM', 'windows_11_3_8_custom');
createConstant('WINDOWS_11_3_8_EXPRESS', 'windows_11_3_8_express');
createConstant('WINDOWS_11_3_7_CUSTOM', 'windows_11_3_7_custom');
createConstant('WINDOWS_11_3_7_EXPRESS', 'windows_11_3_7_express');
createConstant('WINDOWS_11_3_6_CUSTOM', 'windows_11_3_6_custom');
createConstant('WINDOWS_11_3_6_EXPRESS', 'windows_11_3_6_express');
createConstant('WINDOWS_11_3_5_2_CUSTOM', 'windows_11_3_5_2_custom');
createConstant('WINDOWS_11_3_5_2_EXPRESS', 'windows_11_3_5_2_express');
createConstant('WINDOWS_11_3_5_1_CUSTOM', 'windows_11_3_5_1_custom');
createConstant('WINDOWS_11_3_5_1_EXPRESS', 'windows_11_3_5_1_express');
createConstant('WINDOWS_11_3_5_CUSTOM', 'windows_11_3_5_custom');
createConstant('WINDOWS_11_3_5_EXPRESS', 'windows_11_3_5_express');
createConstant('WINDOWS_11_3_4_1_CUSTOM', 'windows_11_3_4_1_custom');
createConstant('WINDOWS_11_3_4_1_EXPRESS', 'windows_11_3_4_1_express');
createConstant('WINDOWS_11_3_4_CUSTOM', 'windows_11_3_4_custom');
createConstant('WINDOWS_11_3_4_EXPRESS', 'windows_11_3_4_express');
createConstant('WINDOWS_21_CUSTOM', 'windows_21_custom');
createConstant('WINDOWS_21_EXPRESS', 'windows_21_express');
createConstant('WINDOWS_21_UPDATE1', 'windows_21_update1');
createConstant('WINDOWS_21_UPDATE2', 'windows_21_update2');
createConstant('WINDOWS_21_UPDATE3', 'windows_21_update3');

//Page Name
createConstant('LIN_CUSTOMERINFO_INSTALLDIR', 'linCustomerInfoAndInstallDir');
createConstant('LIN_FEATURESELECTION', 'linFeatureSelection');
createConstant('LIN_IDENTITYSERVERCONFIG1', 'linIdentityServerConfig1');
createConstant('LIN_IDENTITYSERVERCONFIG2', 'linIdentityServerConfig2');
createConstant('LIN_IDENTITYSERVERCONFIG3', 'linIdentityServerConfig3');
createConstant('LIN_IDENTITYMANAGERCONFIG', 'linIdentityManagerConfig');
createConstant('LIN_TELEMETRYSERVERCONFIG', 'linTelemetryServerConfig');
createConstant('LIN_TOPOLOGYCONFIG', 'linTopologyConfig');
createConstant('LIN_REMOTEREPOSITORY', 'linRemoteRepository');
createConstant('LIN_REGISTERASSERVICE', 'linRegisterAsService');
createConstant('LIN_SUMMARY', 'linSummary');
createConstant('LIN_FINALPAGE', 'linFinalPage');
createConstant('WIN_CUSTOMERINFO_INSTALLDIR', 'winCustomerInfoAndInstallDir');
createConstant('WIN_FEATURESELECTION', 'winFeatureSelection');
createConstant('WIN_REMOTEREPOSITORY', 'winRemoteRepository');
createConstant('WIN_TOPOLOGYCONFIG', 'winTopologyConfig');
createConstant('WIN_IDENTITYCONFIG', 'winIdentityConfig');
createConstant('WIN_TELEMETRYCONFIG', 'winTelemetryConfig');
createConstant('WIN_WEB_MobileVDS', 'winWebAndMobileVDS');
createConstant('WIN_PORTAL_mdxVDS', 'winPortalAndmdxVDS');
createConstant('WIN_OFFICECONFIG', 'winOfficeConfig');
createConstant('WIN_INTELLIGENCECONFIG', 'winIntelligenceConfig');
createConstant('WIN_NARROWCASTCONFIG', 'winNarrowcastConfig');
createConstant('WIN_SUMMARY', 'winSummary');
createConstant('WIN_FINALPAGE', 'winFinalPage');
